import type { PayoutItem } from "libs/codegen/property-onboarding";

export const getPayoutLabel = (item: Pick<PayoutItem, "name" | "trailingNumber">) =>
    `${item.name}${item.trailingNumber !== null ? ` ∗∗∗∗${item.trailingNumber}` : ""}`;
